import { EffectsCommandMap } from 'dva';
import { ConnectState, UserModelState } from '@/models/connect';
import userPermission from '@/permissions/UserPermission';
import type { ChangeAction, OnMount_Page_Action, OnUnmount_Page_Action } from './types';
import { initialState } from './initialState';

export const pageEffects = {
  *onMount_Page({}: OnMount_Page_Action, { call, put }: EffectsCommandMap) {
    const data: UserModelState['info'] = yield call(userPermission.getUserInfo);
    if (!data) {
      return;
    }
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        userInfo: {
          userID: data.userId,
          userName: data.username,
        },
      },
    });
  },
  *onUnmount_Page({}: OnUnmount_Page_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...initialState,
      },
    });
  },
};
